import { createFileRoute, redirect } from '@tanstack/react-router'
import { TeacherSurveyPage } from '@unsw/features/teacher-dashboard'
import { getUserRole } from '@unsw/hooks'

export const Route = createFileRoute('/dashboard/teacher-survey')({
  beforeLoad: () => {
    const { isTeacher, isAdmin } = getUserRole()
    if (!isTeacher && !isAdmin) {
      throw redirect({ to: '/dashboard' })
    }
  },
  component: TeacherSurveyPage,
})
